export default "__VITE_ASSET__B_ZhzLyZ__"